export default "__VITE_ASSET__C40h1TWl__"